import { Typography } from '@packages/ui/shared';

import { ssm5TextStyles } from '../ssm5.styles';

/** Props for {@link Ssm5SectionTitle}. */
export type Ssm5SectionTitleProps = {
    /** The title text. */
    children: string;
};

/**
 * Section heading of the SSM5 page columns.
 *
 * @param props - {@link Ssm5SectionTitleProps}
 * @returns the section title
 */
export function Ssm5SectionTitle({ children }: Ssm5SectionTitleProps) {
    return (
        <Typography style={ssm5TextStyles.sectionTitle} variant="h3">
            {children}
        </Typography>
    );
}
